function teaserBoxWrapLink() {
    // for each teaser box, set a click event containing the url in the .c-link
    $('.c-composition-teaserbox_container, .c-composition-teaserbox-banner_container').each(function () {
        var link = $(this).find('.c-link a');
        var href = link.attr('href');
        if (link.hasClass('link_extern')) {
            $(this).bind('click', function () {
                window.open(href);
            });
        } else {
            $(this).bind('click', function () {
                location.href = href;
            });
        }
    });
    // vehicle teaserboxes: use only main link
    $('.c-composition-teaserbox-vehicle_container').each(function () {
        var link = $(this).find('.button-mainlink .c-link a');
        var href = link.attr('href');
        if (link.hasClass('link_extern')) {
            $(this).find('.image').bind('click', function () {
                window.open(href);
            });
        } else {
          // link may have changed (vermietung)
          var that = this;
          $(this).find('.image').bind('click', function () {
            location.href = $(that).find('.button-mainlink .c-link a').attr('href'); //href;
          });
        }
    });
}

var active = false;
function teaserAdjustHeight() {
    if (active) {
        return;
    }

    active = true;

    var maxHeightText = 0;
    var maxHeightBox = 0;
    var selectorBox = $('.c-composition-teaserbox_container');

    // reset height
    selectorBox.each(function () {
        $(this).css('height', 'auto');
        $(this).find('.textbox').css('height', 'auto');
    });

    // get highest teaserbox
    selectorBox.each(function () {
        if ($(this).find('.textbox').outerHeight() > maxHeightText) {
            maxHeightText = $(this).find('.textbox').outerHeight();
        }
    });
    maxHeightText = Math.round((maxHeightText + 1));

    // apply max height to all teaserboxes
    selectorBox.each(function () {
        $(this).find('.textbox').outerHeight(maxHeightText);
    });

    // get highest teaserbox
    maxHeightBox = maxHeightText;
    selectorBox.each(function () {
        if ($(this).outerHeight() > maxHeightBox) {
            maxHeightBox = $(this).outerHeight();
        }
    });
    maxHeightBox = Math.round((maxHeightBox + 1));

    // apply max height to all teaserboxes
    selectorBox.each(function () {
        $(this).outerHeight(maxHeightBox);
    });

    active = false;
}

window.addEventListener("DOMContentLoaded", function() {
    setTimeout(function () {
        teaserBoxWrapLink();
        teaserAdjustHeight();
    });
});

window.addEventListener("load", function() {
    setTimeout(function () {
        teaserBoxWrapLink();
        teaserAdjustHeight();
    }, 200);
});

window.addEventListener("resize", function() {
    setTimeout(teaserAdjustHeight, 200);
});

window.addEventListener("orientationchange", function() {
    setTimeout(teaserAdjustHeight, 200);
});
